module.exports = __webpack_public_path__ + "static/media/logo.a32a2254.png";